// extracted by css-extract-rspack-plugin
export default {"footer":"VA4ep"};